module.exports = __webpack_public_path__ + "static/media/patrick-tomasso-gMes5dNykus-unsplash.eda17f27.jpg";